import { Action } from '@wix/add-panel-common';
import { useContext, useMemo } from 'react';
import { ActionsDispatcherContext } from '../ActionsDispatcherContext';
import type { UseSavedComponentActionsDispatcher } from './useSavedComponentActionsDispatcher.types';

export const useSavedComponentActionsDispatcher = (): UseSavedComponentActionsDispatcher => {
  const { dispatchAction } = useContext(ActionsDispatcherContext);

  return useMemo(
    () => ({
      dispatchMyDesignsSectionMount: () => dispatchAction({ type: Action.SavedComponentsMyDesignsSectionMount }),
      dispatchSavedComponentAppeared: (payload) =>
        dispatchAction({ type: Action.SavedComponentsComponentAppeared, payload }),
      dispatchAddComponent: (payload) => dispatchAction({ type: Action.SavedComponentsAdd, payload }),
      dispatchAddComponentAndApplyTheme: (payload) => dispatchAction({ type: Action.SavedComponentsAdd, payload }),
      dispatchRenameItem: (payload) => dispatchAction({ type: Action.SavedComponentsRename, payload }),
      dispatchDeleteItem: (payload) => dispatchAction({ type: Action.SavedComponentsDelete, payload }),
      dispatchComponentClick: (payload) => dispatchAction({ type: Action.SavedComponentsAdd, payload }),
      dispatchStartComponentDrag: (payload) => dispatchAction({ type: Action.SavedComponentsStartDrag, payload }),
      dispatchSavedComponentFooterCTAClick: () => dispatchAction({ type: Action.SavedComponentsFooterCTAClick }),
    }),
    [dispatchAction],
  );
};
